/* eslint-disable @typescript-eslint/interface-name-prefix */
import React, { useEffect, useState } from 'react'
import MobilePicker from 'react-mobile-picker'
import './index.less'
import scrollLock from '../../utils/scroll-lock'

const RcPicker = MobilePicker as any
const { Column, Item } = MobilePicker as any

interface IProps {
  title?: string
  confirmTxt?: string
  onCancel: () => void
  onConfirm: (result: object) => void
  onChange?: (name, value) => void
  optionGroups: Record<string, string[]> | undefined
  valueGroups: Record<string, string> | undefined
  itemHeight?: number
  height?: number
}

export default function Picker(props) {
  useEffect(() => {
    scrollLock.enable()

    return () => {
      scrollLock.disable()
    }
  }, [])

  const { onCancel, value, itemHeight, onChange, height, title, selectData, onConfirm, confirmTxt, modalClass } = props
  const [currentData, setCurrentData] = useState<string>(value)
  return (

    <div className="pickerModalWrapper">
      <div
        className="pickerModalMask"
        onClick={onCancel}
      ></div>
      <div className="pickerModal pickerModalToggle">
        <div className="closeIcon" onClick={onCancel}></div>
        <div className="title">{title || '请选择'}</div>
        <RcPicker className="rc-picker" height={height || 400} itemHeight={itemHeight} value={value} onChange={(data)=>setCurrentData(data.value)} wheel="off">
          {Object.keys(selectData).map(key => (
            <Column key={key} name={key}>
              {selectData[key].map(item => (
                <Item style={{ color: value.value == item.value ? 'black' : '#ccc' }} key={item.value} value={item.value}>
                  {item.label}
                </Item>
              ))}
            </Column>
          ))}
        </RcPicker>
        <div className="okBtn" onClick={() => onConfirm(currentData)}>{confirmTxt || '确认'}</div>
      </div>
    </div>
  )
}
